import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";

// Hero and right content images
import heroImg from "../../assets/9.jpg"; 
import contentImg from "../../assets/m11.webp"; // starting image for right content

// Import project images m11.webp se m66.webp
import m11 from "../../assets/m11.webp";
import m22 from "../../assets/m22.webp";
import m33 from "../../assets/m33.jpg";
import m44 from "../../assets/m44.webp";
import m55 from "../../assets/m55.webp";
import m66 from "../../assets/m66.webp";

const projectImages = [m11, m22, m33, m44, m55, m66];

const HotelLift = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="hero-fullwidth h-[430px] flex items-center justify-start px-6 md:px-12 hero-bg-color">

        <motion.div
          className="relative p-4 md:p-6 rounded-md"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">
            Home
          </p>
          <h1 className="text-white text-2xl md:text-4xl font-bold">Hotel Lifts</h1>
        </motion.div>
      </div>

      {/* Content Section */}
      {/* Content Section */}
<div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-center gap-10">
  {/* Left Content */}
  <motion.div
    className="w-full md:w-1/2 space-y-6"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={{
      hidden: { opacity: 0, x: 80 },
      visible: { opacity: 1, x: 0, transition: { duration: 1 } },
    }}
  >
    <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
      In recent years, low-rise apartments have increasingly incorporated lift 
      facilities to enhance convenience for residents, as they are now considered 
      a necessity. Beyond practicality, lifts significantly contribute to increasing 
      property value, serving as a key selling point for builders and homeowners alike, 
      while also boosting the overall appeal of the property.
    </motion.p>
    <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
      To optimize space, low-rise apartments can choose compact lift models designed 
      to occupy minimal area.
    </motion.p>
    <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
      Architects, builders, or flat associations can reach out to us for lift 
      installation or modernization services. Contact us today to explore the ideal 
      lift solutions for your residential property!
    </motion.p>
  </motion.div>

{/* Right Image */}
<motion.div
  className="w-full md:w-1/2 overflow-hidden rounded-2xl shadow-2xl"
  initial={{ opacity: 0, x: -80 }}
  whileInView={{ opacity: 1, x: 0 }}
  transition={{ duration: 1 }}
>
  <img
    src={contentImg}
    alt="Hotel Lift"
    className="w-full max-h-[400px] object-cover rounded-2xl"
  />
</motion.div>

</div>


      {/* Projects Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10"
          initial={{ opacity: 0, y: -80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          SOME PROJECTS
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: -120 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Slider {...sliderSettings}>
            {projectImages.map((img, idx) => (
              <motion.div
                key={idx}
                className="px-2"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
              >
                <img
                  src={img}
                  alt={`Project ${idx + 1}`}
                  className="w-full h-64 md:h-72 object-cover rounded-2xl shadow-lg"
                />
              </motion.div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </div>
  );
};

export default HotelLift;
